import './index.css';
// Tracking main.js
// Main entry point - v1.0.3 - 2025-11-25T20:00:00Z

// React Router 6 + StrictMode fires a benign "Transition was skipped" AbortError
// when double-invocation cancels an in-flight navigation. Suppress it globally.
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.name === 'AbortError' && event.reason?.message === 'Transition was skipped') {
    event.preventDefault();
  }
});
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

const root = document.getElementById("cmogryj7i00bj0v0ygcpz82l5-root");
ReactDOM.createRoot(document.getElementById("cmogryj7i00bj0v0ygcpz82l5-root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Add "Made with maker" badge
const link = document.createElement('a');
link.href = 'https://ai.maker.co';
link.target = '_blank';
link.rel = 'noopener noreferrer';
link.style.position = 'fixed';
link.style.bottom = '12px';
link.style.left = '12px';
link.style.textDecoration = 'none';
link.style.zIndex = '9999';
link.style.display = 'flex';
link.style.alignItems = 'center';
link.style.gap = '6px';
link.style.padding = '8px 12px';
link.style.borderRadius = '4px';
link.style.backgroundColor = 'rgba(250, 248, 245, 0.85)'; // cream-light with opacity
link.style.backdropFilter = 'blur(8px)';
link.style.border = '1px solid rgba(216, 207, 192, 0.3)'; // cream-dark border
link.style.color = '#57534e'; // stone
link.style.fontFamily = 'Inter, sans-serif';
link.style.fontSize = '11px';
link.style.fontWeight = '500';
link.style.letterSpacing = '0.02em';
link.style.transition = 'all 200ms ease';
link.style.boxShadow = '0 2px 8px rgba(42, 40, 37, 0.08)';

// Add hover effect
link.addEventListener('mouseenter', () => {
  link.style.backgroundColor = 'rgba(250, 248, 245, 0.95)';
  link.style.transform = 'translateY(-1px)';
  link.style.boxShadow = '0 4px 12px rgba(42, 40, 37, 0.12)';
});

link.addEventListener('mouseleave', () => {
  link.style.backgroundColor = 'rgba(250, 248, 245, 0.85)';
  link.style.transform = 'translateY(0)';
  link.style.boxShadow = '0 2px 8px rgba(42, 40, 37, 0.08)';
});

// Create icon
const icon = document.createElement('span');
icon.style.display = 'flex';
icon.style.alignItems = 'center';
icon.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
  <path d="M2 17l10 5 10-5"></path>
  <path d="M2 12l10 5 10-5"></path>
</svg>`;

link.appendChild(icon);

const text = document.createTextNode('Made with maker');
link.appendChild(text);

document.body.appendChild(link);
